import { createSlice } from '@reduxjs/toolkit';

// Kiểm tra localStorage hoặc mặc định là true (có GPU)
const getInitialState = () => {
    try {
        const saved = localStorage.getItem('highPerformance');
        return saved !== null ? JSON.parse(saved) : true;
    } catch (e) {
        return true;
    }
};

export const performanceSlice = createSlice({
    name: 'performance',
    initialState: {
        highPerformance: getInitialState(),
    },
    reducers: {
        togglePerformance: (state) => {
            state.highPerformance = !state.highPerformance;

            // Lưu vào localStorage
            try {
                localStorage.setItem('highPerformance', JSON.stringify(state.highPerformance));
            } catch (e) {
                console.error('Lỗi khi lưu cài đặt:', e);
            }

            // Cập nhật class no-gpu
            if (state.highPerformance) {
                document.documentElement.classList.remove('no-gpu');
            } else {
                document.documentElement.classList.add('no-gpu');
            }
        },
    },
});

export const { togglePerformance } = performanceSlice.actions;

export default performanceSlice.reducer;
